import { ReactElement, JSX } from 'react';

import {
  Typography,
  Label,
} from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

import { CustomIcon } from ':components/CustomIcon';
import { ServiceItem } from ':types';

type ServiceContentProps = Pick<
  ServiceItem,
  'name' | 'description' | 'icon' | 'is_lan' | 'color'
> & {
  arrowIcon?: JSX.Element | null;
};

export function ServiceContent({
  name,
  description,
  icon,
  color,
  is_lan,
  arrowIcon = null,
}: ServiceContentProps): ReactElement {
  const { background, main } = color;

  return (
    <div className={styles.serviceBlock}>
      <div className={styles.serviceContainer}>
        <CustomIcon iconName={icon} color={main} background={background} />
        <div className={styles.textContainer}>
          <Typography variant='body2' className={styles.title}>
            {name}
          </Typography>
          {description && (
            <Typography className={styles.description} variant='body3'>
              {description}
            </Typography>
          )}
          {is_lan && <Label title='Внутренняя сеть' className={styles.chip} />}
        </div>
      </div>
      {arrowIcon}
    </div>
  );
}
